module.exports = __webpack_public_path__ + "static/miciv-cover-c9d9fad723273fd0c9f0bdeec1df73b5.png";